import fetch from '../config/api'
/**
 * 活动首页接口(已结)
 * param {p} 平台，w、wx
 * param {language} 1 表示汉语 2表示英语 3表示藏语
 */
const ActivityIndex = (language = '1') => fetch('/activity/index', {
    p: 'wx',
    language
});

/**
 * 活动列表(已结)
 * param {p} 平台，w、wx
 * param {language} 1 表示汉语 2表示英语 3表示藏语
 * param {type} 1 普通活动 2表示专题活动 3表示少儿活动
 * param {num} 分页时表示从第几条开始取
 * param {take} 分页时该值表示每页多少条数据
 */
const ActivityList = (language = '1', type = '1', num = '0', take = '10') => fetch('/activity/activity_list', {
    p: 'wx',
    language,
    type,
    skip: num * take, //从第几个开始
    take //取几条数据
});

/**
 * 活动详情(已结)
 * param {p} 平台，w、wx
 * param {language} 1 表示汉语 2表示英语 3表示藏语
 * param {activity_id} 活动ID
 */
const ActivityDetail = (language = '1', activity_id) => fetch('/activity/activity_detail', {
    p: 'wx',
    language,
    activity_id
});

export default {
    ActivityIndex,
    ActivityList,
    ActivityDetail
}